<template>
  <f7-page name="recommendfriendHistory">
    <bc-navbar></bc-navbar>
    <div class="page_single layout_fullwidth_padding">
      <page-header :title="title" :backUrl="backLink">
        <template v-slot:headerIcon>
          <img src="/static/svg/referral.svg" alt="referral icon" />
        </template>
      </page-header>
      <section class="page-content">
        <referrals-filter
          class="filter"
          :value="historyFilter"
          @change="onFilterChange($event)"
          :options="statuses"
        />
        <div class="history-list" ref="historyList" v-if="history.length">
          <referral-history-item
            v-for="item in history"
            :key="item.referralHistoryId"
            :data="item"
            @openMenu="openHistoryItemMenu(item)"
          />
        </div>
        <span class="no-content" v-if="!history.length && historyLoaded"
          >no referrals yet</span
        >
        <div class="buttons fx fx-col">
          <button class="button" :style="buttonStyle" @click="onAddReferral()">Add More Referrals</button>
          <a class="button" :href="referUrl">View My Referral Page</a>
        </div>
      </section>
    </div>

    <f7-actions :opened="actionsOpened" @close="actionsOpened = false">
      <f7-actions-group>
        <f7-actions-button @click="edit()">Edit</f7-actions-button>
        <f7-actions-button
          v-if="referral.status !== ReferralProgramHistoryStatus.Pending"
          @click="sendReferral()"
          >Send</f7-actions-button
        >
        <f7-actions-button
         v-else @click="resendReferral()"
          >Resend</f7-actions-button
        >
      </f7-actions-group>
    </f7-actions>

    <edit-referral-modal
      :opened="editReferralOpened"
      :referralData="referral"
      :buttonStyle="buttonStyle"
      @close="editReferralOpened = false" 
      @edit="submitEditReferral($event)" 
      @remove="remove($event)"></edit-referral-modal>

      <add-referral-modal
      :opened="addReferralOpened"
      :buttonStyle="buttonStyle"
      @close="addReferralOpened = false" 
      @submit="submitNewReferral($event)" 
      @cancel="addReferralOpened = false"></add-referral-modal>

      <loader :show="showLoader" />

  </f7-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import ReferralsFilter from '../../components/referral/referrals-filter.vue'
import ReferralsHistoryItem from '../../components/referral/referral-history-item.vue'
import EditReferralModal from '../../components/referral/edit-referral-modal.vue'
import AddReferralModal from '../../components/referral/add-referral-modal.vue'
import Loader from '@components/loader.vue'
import { PAGES } from '../../shared/routes.constants'
import { ReferralProgramHistoryStatus } from '@/shared/enums/referral.enum.js'
import { notify } from '@/shared/notifications.js'
import { openSMSEditor } from '@/helpers/sms-editor.js'
/* eslint-disable */

export default {
  name: "recomend-friend",
  components: {
    loader: Loader,
    "referrals-filter": ReferralsFilter,
    "referral-history-item": ReferralsHistoryItem,
    "edit-referral-modal": EditReferralModal,
    "add-referral-modal": AddReferralModal
  },
  mounted: async function() {
    this.loading = true;
    try {
      await this.loadHistory();
      await this.getStatuses();
      await this.getReferralProgramInfo();
    } catch (error) {
      console.error(error);
    } finally {
   this.loading = false;
}
   
  },
  computed: {
    ...mapState({
      customization: (state) => state.common.customization,
    }),
    ...mapGetters({
      history: "recommendFriend/history",
      statuses: "recommendFriend/statuses",
      historyLoaded: "recommendFriend/historyLoaded",
    }),
    buttonStyle() {
      return {
        color: this.customization.fontColor,
        "background-color": this.customization.mainColor,
      };
    },
    showLoader(){
      return !this.historyLoaded || this.loading
    }
  },
  methods: {
    ...mapActions({
      getHistory: "recommendFriend/loadRecommendFriendHistory",
      getStatuses: "recommendFriend/loadHistoryStatuses",
      editReferral: "recommendFriend/editReferral",
      deleteReferral: "recommendFriend/deleteReferral",
      getReferralProgramInfo: "recommendFriend/getInfo",
      addReferral: "recommendFriend/addReferral",
      getReferralMessage: "recommendFriend/getReferralMessage",
      sendSmsAction: "recommendFriend/sendSmsAction"
    }),
    async onFilterChange(value) {
      this.historyFilter = value;
      await this.loadHistory();
    },
    async loadHistory() {
      this.resetScroll();
      await this.getHistory(this.historyFilter);
    },
    openHistoryItemMenu(referral) {
      this.actionsOpened = true;
      this.referral = referral;
      this.listenActionsOverlay(() => {
        this.actionsOpened = false;
        this.clearReferral();
      });
    },
    edit() {
      this.actionsOpened = false;
      this.editReferralOpened = true;
      this.listenActionsOverlay(() => {
        this.closeEditModal();
        this.clearReferral();
      });
    },
    async sendReferral() {
      await this._sendReferral(this.referral.referralContactPhone, this.referral.code);
    },
    async resendReferral() {
      await this._sendReferral(this.referral.referralContactPhone, this.referral.code);
    },
    async _sendReferral(phone, code){
      this.loading = true
      this.actionsOpened = false;
      const res = await this.getReferralMessage(code)
      if(!res.success){
        notify.error('Error during get message text')
        return
      }
      const text  = res.model
      openSMSEditor(phone, text)
      try {
        await this.sendSmsAction(code)
      } catch (error) {
        notify.error(error.message)
        return
      }
      notify.success("Message was sent successfully!");
      await this.loadHistory();
      this.loading = false
    },
    submitEditReferral(referral) {
      this.loading = true
      const req = {
        referralHistoryId: referral.referralHistoryId,
        fullName: referral.firstName + ' ' + referral.lastName,
        phone: referral.phone
      }
      this.editReferral(req).then((res)=>{
        if(res.success){
          notify.success('Saved!')
        } else{
         notify.error('Error during save refarral')
        }
      }).catch((err)=>{
        notify.error('Error during save refarral')
      }).finally(()=>{
        this.loading = false;
        this.closeEditModal();
      });
    },
    submitNewReferral(referral){
      this.loading = true
      this.addReferralOpened = false
      this.referral = referral;
      this.referral.referralContactPhone = referral.phone
      this.addReferral({
        refferals:[{
        fullName: this.referral.firstName + " " + this.referral.lastName,
        phone: this.referral.referralContactPhone,
      }]
      }).then((res) => this.onAddReferralResult(res))
        .catch((err)=>{
          console.error(err);
          notify.error("Referral save error");
        })
        .finally(()=>{
          this.loading = false;
        });
    },
    remove(historyId) {
      this.loading = true
      this.deleteReferral(historyId).then((res)=>{
        if(res.success){
          notify.success('Deleted successfully!');
        } else{
          notify.error('Error during delete refarral')
        }
      }).catch((err)=>{
        notify.error('Error during delete refarral')
      }).finally(()=>{
        this.loading = false;
        this.closeEditModal();
      });

    },
    clearReferral(){
      this.referral = {};
    },
    closeEditModal() {
      this.editReferralOpened = false;
    },
    listenActionsOverlay(fn) {
      // its a trick
      const overlay = document.querySelector(".modal-overlay");
      if (!overlay) {
        return;
      }

      const handler = () => {
        fn();
        overlay.removeEventListener("click", handler);
      };

      overlay.addEventListener("click", handler);
    },
    onAddReferral(){
      this.addReferralOpened = true;
       this.listenActionsOverlay(() => {
        this.addReferralOpened = false;
      });
    },
    resetScroll(){
      if(!this.$refs.historyList){
        return 
      }
      this.$nextTick(() => {
            this.$refs.historyList.scrollTop = 0;
        });
    },
    onAddReferralResult(res){
      if (res.success) {
            this.referral.code = res.model[0].referralCode;
            this.sendReferral();
      }
    }
  },
  data() {
    return {
      title: "Referral History",
      backLink: PAGES.RacommendAFriend,
      historyFilter: ReferralProgramHistoryStatus.None,
      referUrl: PAGES.RacommendAFriend,
      actionsOpened: false,
      editReferralOpened: false,
      addReferralOpened: false,
      referral: {},
      ReferralProgramHistoryStatus: ReferralProgramHistoryStatus,
      loading: false
    };
  },
};
</script>
<style scoped>
.page_single {
  height: 100%;
  display: flex;
  flex-direction: column;
  padding-bottom: 15px;
  box-sizing: border-box;
}

.page-content {
  position: relative;
  padding-top: 0 !important;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.page_title {
  margin-inline: 0;
  display: inline-flex;
  gap: 5px;
  margin-bottom: 1px solid rgba(0, 0, 0, 0.4);
}

.filter {
  margin-bottom: 24px;
}

.history-list {
  display: grid;
  gap: 8px;
  overflow-y: auto;
  flex: 1;
  margin-bottom: 15px;
  align-content: flex-start;
}

.buttons{
  margin-top: auto;
  gap: 10px;
}

.button {
  min-height: 40px;
  display: block;
  padding: 0 15px;
  border-radius: 5px;
}

.no-content {
  color: #8f8e8e;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// recommend-friend-history.vue?a459d0f6